import React, { useState, useImperativeHandle } from "react";

import { MAX_PRICE_IMPACT } from "../../utils/constants";
import ModalDialog from "../Modal";

type Props = {
  onRef: React.RefObject<unknown>;
  slippageRate: string;
  setSlippageRate: React.Dispatch<React.SetStateAction<string>>;
};

export default function Impact(props: Props) {
  const { slippageRate, setSlippageRate } = props;
  const [openImpactConfig, setOpenImpactConfig] = useState(false);
  const [maxImpactRate, setMaxImpactRate] = useState("0.1");
  // const [radioRate, setRadioRate] = useState("0.1");

  useImperativeHandle(props.onRef, () => {
    return {
      close: handleCloseImpactConfig,
      open: handleOpenImpactConfig,
      // rate: 1 - Number(radioRate) / 100,
    };
  });

  const handle_maxImpactRate = (v: any) => {
    setMaxImpactRate(v.target.value);
  };
  const handle_radio = (v: string) => {
    const value = v;
    if (value !== "other") {
      setSlippageRate(value);
    } else {
      setSlippageRate(maxImpactRate);
    }
    if (value !== "Other") {
      setMaxImpactRate(value);
    }
  };

  const handleCloseImpactConfig = () => {
    setOpenImpactConfig(false);
  };
  const handleOpenImpactConfig = () => {
    setOpenImpactConfig(true);
  };

  return (
    <ModalDialog
      title="Swap Settings"
      open={openImpactConfig}
      handleClose={handleCloseImpactConfig}
    >
      <div className="flex flex-col p-4 w-full gap-6">
        <p className="text-gray-100">Slippage Settings</p>
        <div className="flex w-full rounded-lg bg-black p-1">
          {MAX_PRICE_IMPACT?.map((item, index) => (
            <div
              className={`flex justify-center border border-black items-center hover:rounded-lg hover:bg-primary-100 p-3 w-1/5 cursor-pointer ${
                slippageRate === item && "bg-primary-100 rounded-lg"
              }`}
              onClick={() => handle_radio(item)}
              key={index}
            >
              <p className="text-gray-400 text-center">{item}%</p>
            </div>
          ))}

          <div
            className={`flex w-2/5 h-full rounded-r-lg bg-black p-3 ${
              slippageRate === "Other" &&
              "border border-primary-200 bg-primary-100 rounded-lg"
            }
            }`}
            onClick={() => handle_radio("Other")}
          >
            <p className="text-gray-400">Custom</p>
            <input
              value={maxImpactRate}
              className="w-full bg-transparent outline-none text-gray-400 disabled:text-gray-400"
              onChange={handle_maxImpactRate}
            />
            <p className="text-gray-400">%</p>
          </div>
        </div>
        <button
          onClick={handleCloseImpactConfig}
          className="w-full py-2 text-white text-lg rounded-lg bg-black bg-opacity-70"
        >
          Save Settings
        </button>
      </div>
    </ModalDialog>
  );
}
